import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { UserService } from 'services/user.service';
import { ApplicationService } from 'services/application.service';
import { AlertService } from 'services/alert.service';
import { DatePipe } from '@angular/common';
import { ProductService } from 'services/product.service';
import { ChangeRequestModelComponent } from './changerequestmodel.component';
import { MatDialog, MatDialogConfig } from '@angular/material';

@Component({
  selector: 'app-changeofservice',
  templateUrl: './changeofservice.component.html',
  styleUrls: ['./changeofservice.component.scss']
})

export class ChangeofserviceComponent implements OnInit {
  form: FormGroup;
  srcApplicationList : any[];
  applicationList : any[];
  srcProductList : any[];
  productList : any[];
  dropdownSettings = {};
  serviceChangeDetails = {
    referenceNumber: '',
    productName: '',
    monthlyFees: '',
    address: '',
    cancellationDate: '',
    connectionInitiatedDate: '',
    reasonType: '',
    comments: ''
};
min: Date;
max: Date;

  showDetails = false;
  showProducts = false;
  width: number = window.innerWidth;
  public myFilter = (d: Date): boolean => {
    // const day = d.getDay();
    // // Prevent Saturday and Sunday from being selected.
    // return day !== 0 && day !== 6;

    // const day = d.getDay();
    // // Prevent Saturday and Sunday from being selected.
    // return day !== 0 && day !== 6;

    const date = d.getDate();

    this.form.value.cancellationDate = this.transformDate(d);

    return date == 1;
}
  carouselSize: number;

  constructor(private formBuilder: FormBuilder,
    private userService: UserService,
    private applicationService:ApplicationService,
    private productservice: ProductService,
     private alertService: AlertService,
     private datePipe: DatePipe,
     public dialog: MatDialog,)
      {
      this.initializeValidators();
     this.dropdownSettings = {
       singleSelection: false,
       idField: 'key',
       textField: 'value',
       selectAllText: 'Select All',
       unSelectAllText: 'Un Select All',
       itemsShowLimit: 4,
       allowSearchFilter: true
   };

   
   }

   

  ngOnInit() {

    if (this.width <= 1100) {
      this.carouselSize = 1;
    }
    else {
      this.carouselSize = 2;
    }


    var newDate = new Date();
    newDate.setMonth(newDate.getMonth() + 2);
    var date = new Date(newDate.getFullYear(), newDate.getMonth(), 1);
    this.min = date;


    this.getApplicationList(false);
    this.getProductList(true);
  }

  getApplicationList(refresh) {
    this.userService.getApplicationList(refresh).subscribe(result => {

      this.srcApplicationList = [];
      this.applicationList = [];
      this.srcApplicationList = result;
      var keyValue = 0;

      this.srcApplicationList.forEach(applicationItem => {
        if(applicationItem.vumatelNetworkIdentifier){
          this.applicationList.push({key : keyValue, value: applicationItem.referenceNumber});
          keyValue = keyValue + 1;
        }
      });
    });
  }

  getProductList(refresh)
  {
    try {
        this.productservice.getProductList(refresh).subscribe(result => {
             this.srcProductList = [];
            this.srcProductList = result;
        //     this.recurringProductList = [];
        //     this.onceOffProductList= [];
        //     this.recurringProductList =result.filter(element => {
        //       return element.subCategoryId == 2;
        //   });
        //   this.onceOffProductList =result.filter(element => {
        //     return element.subCategoryId == 1;
        // });
        });

      } catch (error) {

       }
  }


  transformDate(date) {
    return this.datePipe.transform(date, 'yyyy/MM/dd');
  }

  initializeValidators() {
    this.form = this.formBuilder.group({
      
      application: [''],
       });
  }

  getProducts() {
    this.showProducts = true;
  }

  onSubmit()
  {
    if(this.form.value.application.value){

      this.srcApplicationList.forEach(applicationItem => {
        if(applicationItem.referenceNumber == this.form.value.application.value){
          var application = applicationItem;

          // this.productList = this.srcProductList;
          this.srcProductList.forEach(productItem => {
            if(productItem.id == application.productId){
              this.productList = this.srcProductList.filter(element => {
                return element.subCategoryId == productItem.subCategoryId && element.id != productItem.id;
            });

            }
          });

        }
      });

      this.applicationService.getCustomerInfoForCancellation(this.form.value.application.value).subscribe(response => {
        this.serviceChangeDetails = response;
  
        if(response && response.referenceNumber){
          this.showDetails = true;
        }
        else
          {
            this.showDetails = false;
            this.alertService.warning('No Record Found!');
          }
      });
    }
    else {
            this.alertService.warning('Please Select Application');
    }
  }

  submitCancellation()
  {
    if(this.form.valid){

      //this.cancellationDetails.cancellationDate = this.form.value.cancellationDate;

    //   var cancellationRequest = {
    //     cancellationDate: this.form.value.cancellationDate,
    //     reasonType: this.form.value.reasonType,
    //     comments: this.form.value.comments,
    //     referenceNumber : this.form.value.application.value
    // };

    //this.cancellationDetails.cancellationDate = this.transformDate(this.form.value.cancellationDate);

    // this.serviceChangeDetails.cancellationDate = this.form.value.cancellationDate;
    // this.serviceChangeDetails.reasonType = this.form.value.reasonType.key;
    // this.serviceChangeDetails.comments = this.form.value.comments;

      this.applicationService.saveCustomerCancellation(this.serviceChangeDetails).subscribe(response => {
        if(!response){
          this.showDetails = true;
          this.alertService.success("Cancellation Requested");
        }
        else
          {
            this.showDetails = false;

            if(response.detail)
              this.alertService.warning(response.detail);

            else if(response)
              this.alertService.warning(response);
          }
      });
    }
    else {
      this.validateFormControl();
            this.alertService.warning('Please fill Required field');
    }
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }

  openOrderNowDialog(value) {

    const dialogConfig = new MatDialogConfig();

    let isBoolean = this.serviceChangeDetails.monthlyFees < value.cost;

    dialogConfig.data = {
      applicationNo: this.form.value.application.value,
      cost: value.cost,
      isUpgrade: isBoolean
    };

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.panelClass = 'mat-dialog';

    const dialogRef = this.dialog.open(ChangeRequestModelComponent, dialogConfig)
    dialogRef.afterClosed().subscribe(data => {
      if (data) {

      }
    });

  }

}
